import {DEFAULT_LIMIT, DEFAULT_OFFSET} from 'constants/pagination'
import {
  START_LOAD_SHIFT_TRANSFER_HISTORY,
  SUCCESS_LOAD_SHIFT_TRANSFER_HISTORY,
  ERROR_LOAD_SHIFT_TRANSFER_HISTORY,
  DATE_CHANGE_FILTER_STH,
  MULTI_SELECT_CHANGE_FILTER_STH,
  APPLY_FILTER_STH,
  CLEAR_FILTER_STH,
  SET_PAGINATION_STH,
  SET_SORTING_STH,
  SUCCESS_LOAD_FILTER_OPTIONS_STH,
  ERROR_LOAD_FILTER_OPTIONS_STH,
  GET_SHIFT_TRANSFER_HISTORY_DETAIL_START,
  GET_SHIFT_TRANSFER_HISTORY_DETAIL_SUCCESS,
  GET_SHIFT_TRANSFER_HISTORY_DETAIL_ERROR,
} from 'store/actions/shiftTransferHistory'
import {mappingToAPI} from 'pages/OperationalJournal/utils'

const OPTIONS_KEY = 'id'

const DEFAULT_PAGINATION = {
  limit: DEFAULT_LIMIT,
  offset: DEFAULT_OFFSET,
}

const DEFAULT_SORT_TABLE = {
  sortOrder: undefined,
  sortBy: undefined,
}

const defaultFilter = {
  dateRange: {},
  executorEmails: [],
  executorOptions: [],
  isChangeFilter: false,
  isEmptyFilter: true,
}

const initialState = {
  dataTable: [],
  pagination: DEFAULT_PAGINATION,
  count: 0,
  lastUpdatedAt: '',
  sorting: DEFAULT_SORT_TABLE,
  filter: defaultFilter,
  isLoadingTable: false,
  isLoadedTable: false,
  isErrorTable: false,
  detail: {
    isLoading: false,
    isLoaded: false,
    data: null,
  },
}

const shiftTransferHistory = (state = initialState, action) => {
  switch (action.type) {
    case START_LOAD_SHIFT_TRANSFER_HISTORY:
      return {...state, isLoadingTable: true}

    case SUCCESS_LOAD_SHIFT_TRANSFER_HISTORY:
      return {
        ...state,
        dataTable: action.data?.items,
        count: action.data?.count,
        lastUpdatedAt: action.data?.lastUpdatedAt,
        isLoadingTable: false,
        isLoadedTable: true,
      }

    case ERROR_LOAD_SHIFT_TRANSFER_HISTORY:
      return {...state, isLoadingTable: false, isLoadedTable: true, isErrorTable: true}

    case DATE_CHANGE_FILTER_STH:
      return {
        ...state,
        filter: {
          ...state.filter,
          dateRange: action.dateRange,
          isChangeFilter: true,
          isEmptyFilter: false,
        },
      }

    case MULTI_SELECT_CHANGE_FILTER_STH:
      return {
        ...state,
        filter: {
          ...state.filter,
          [action.data.key]: mappingToAPI(action.data.items, OPTIONS_KEY),
          isChangeFilter: true,
          isEmptyFilter: false,
        },
      }

    case APPLY_FILTER_STH:
      return {
        ...state,
        filter: {...state.filter, isChangeFilter: false},
        pagination: DEFAULT_PAGINATION,
        sorting: DEFAULT_SORT_TABLE,
      }

    case CLEAR_FILTER_STH:
      return {
        ...state,
        pagination: DEFAULT_PAGINATION,
        filter: {
          ...defaultFilter,
          executorOptions: state.filter.executorOptions,
        },
      }

    case SET_PAGINATION_STH:
      return {...state, pagination: action.data}

    case SET_SORTING_STH:
      return {...state, sorting: action.data}

    case SUCCESS_LOAD_FILTER_OPTIONS_STH: {
      const {data} = action
      return {
        ...state,
        filter: {
          ...state.filter,
          executorOptions: data.executorEmails.map(({email, name}) => ({id: email, name})),
        },
      }
    }

    case ERROR_LOAD_FILTER_OPTIONS_STH:
      return state

    case GET_SHIFT_TRANSFER_HISTORY_DETAIL_START:
      return {...state, detail: {isLoading: true, isLoaded: false, data: null}}

    case GET_SHIFT_TRANSFER_HISTORY_DETAIL_SUCCESS:
      return {...state, detail: {isLoading: false, isLoaded: true, data: action.payload}}

    case GET_SHIFT_TRANSFER_HISTORY_DETAIL_ERROR:
      return {...state, detail: {isLoading: false, isLoaded: true, data: null}}

    default:
      return state
  }
}

export default shiftTransferHistory
